function initMediaButtonHandlers() {
  document.querySelectorAll('.open-media-pswp').forEach((button) => {
    const ariaLabel = button.getAttribute('aria-label');
    const images = document.querySelectorAll('media-gallery img');
    images.forEach((img) => {
      const src = img.getAttribute('src') || img.getAttribute('data-src');
      if (src && src.includes(`-${ariaLabel}`)) {
        const parentWithMediaId = img.closest('[data-media-id]');
        const nextEl = img.nextElementSibling;
        const mediaId = parentWithMediaId.getAttribute('data-media-id');
        if (parentWithMediaId) {
          const targetEl = document.getElementById('mediaAttr');
          if (targetEl) targetEl.click();

          button.setAttribute('data-id', 'data-id' + mediaId);
          if (nextEl) nextEl.id = 'data-id' + mediaId;

          button.addEventListener('click', () => {
            const triggerTarget = document.getElementById('data-id' + mediaId);
            if (triggerTarget) triggerTarget.click();
          });
        }
      }
    });
  });
}

// Initial run
document.addEventListener('DOMContentLoaded', initMediaButtonHandlers);

// Shopify customizer section reload (live editor)
document.addEventListener('shopify:section:load', initMediaButtonHandlers);
document.addEventListener('shopify:section:select', initMediaButtonHandlers);

function scrollToReview() {
  const target = document.querySelector("reviewsio-product-reviews-widget");
  const headerOffset = document.querySelector('header')?.offsetHeight || 80; // adjust default offset as needed

  if (target) {
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

// Attach listener to all clickable review links
document.querySelectorAll('.scroll-to-review').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    scrollToReview();
  });
});
